<div class="max-auto plMd prMd">
    <h2 class="h2 text-dark sa-intro-text__part1 mb20">{{ trimmedHeading }}</h2>
    
    <p *ngFor="let para of amendedParagraphs; let index = index;" 
        [ngClass]="{'sa-intro-text__part2': index < 1, 'sa-intro-text__part3': index > 0 }" 
        class="p p--heading text-dark mb20">{{ para }}</p>
</div>
